var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheHeader'),_vm._t("default"),(_vm.$route.name !== 'login' && _vm.$route.name !== 'line login')?_c('TheFooter'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }